import React, { useEffect, useState } from "react";
import PlanStatus from "../profile-complete/planStatus";
import PersonalInfo from "../profile-complete/personal-information/personal-info";
import CompanyInfo from "../profile-complete/company-information/company-info";
import BankMain from "./bank-account/bank-info";
import DetailMain from "./signIn-lease/main";
import BaseUrl from "../../../constants/BaseUrl";
import { useSelector } from "react-redux";
const MainSection = ({ isComplete }) => {
  const { loginSuccess, profileCompleted, userCompleteProfile } = useSelector(
    (state) => state.auth
  );
  const [activeComponent, setActiveComponent] = useState("PlanStatus"); // Default: PlanStatus show

  const handleButtonClick = (buttonName) => {
    setActiveComponent(buttonName);
  };

  const handleBackToPlanStatus = () => {
    setActiveComponent("PlanStatus");
  };

  const [leaseId, setLeaseId] = useState();

  const GetLeaseWithTenent = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/lease/getLeaseDetailsByTenantId/${loginSuccess?.user?._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          setLeaseId(result.data[0].leaseId);
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    GetLeaseWithTenent();
  }, []);

  return (
    <div className="w-full h-full flex items-center">
      {activeComponent === "PlanStatus" ? (
        <PlanStatus onButtonClick={handleButtonClick} isComplete={isComplete} />
      ) : activeComponent === "Personal Information" ? (
        <PersonalInfo onBack={handleBackToPlanStatus} />
      ) : activeComponent === "Company Information" ? (
        <CompanyInfo onBack={handleBackToPlanStatus} />
      ) : activeComponent === "Bank Account" ? (
        <BankMain onBack={handleBackToPlanStatus} />
      ) : // ) : activeComponent === "Sign Lease" ? (
      //   <DetailMain recordId={leaseId} onBack={handleBackToPlanStatus} />
      // )
      null}
    </div>
  );
};

export default MainSection;
